// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__+wWIt","rotation":"styles_rotation__UYbQ-"};